"use strict";

require("core-js/modules/es.array.reduce.js");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.key = void 0;

function _toConsumableArray(a) {
  return _arrayWithoutHoles(a) || _iterableToArray(a) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(a) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) return Array.from(a);
}

function _arrayWithoutHoles(a) {
  if (Array.isArray(a)) {
    for (var b = 0, c = Array(a.length); b < a.length; b++) {
      c[b] = a[b];
    }

    return c;
  }
}

var key = function key() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : 5;
  {
    return _toConsumableArray(Array(a)).reduce(function (a) {
      return a + "FGHIJNPQRSTUVWXYfghijpqrstuvwxy125678"[~~(Math.random() * "FGHIJNPQRSTUVWXYfghijpqrstuvwxy125678".length)];
    }, "");
  }
};

exports.key = key;